'use strict';

var pdpZoom = require('../pdpZoom/pdpZoom');

pdpZoom.initZoom();